export default __webpack_public_path__ + "static/media/second_tab_howitwork.b9f69f7f.png";